/*
 * Inciclo: regras do "Compre e Ganhe" (snippets/inciclo-brinde.liquid), no carrinho lateral e na página do carrinho.
 * - Escolher/trocar o brinde: remove o brinde atual e adiciona o escolhido (quantidade 1).
 * - Sempre que o carrinho muda: abaixo do mínimo o brinde sai; nunca mais de 1 brinde nem quantidade > 1.
 * O valor mínimo vem do Liquid (data-minimo, em centavos), já que lá estão as configurações do tema.
 */
(function () {
  var ocupado = false;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function json(url, corpo) {
    return fetch(raiz + url, {
      method: corpo ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: corpo ? JSON.stringify(corpo) : undefined,
    }).then(function (r) { return r.json(); });
  }

  // Mesma regra do Liquid: tipo de produto "Brinde" (ou a marca _brinde gravada ao adicionar)
  function brindesNo(cart) {
    return cart.items.filter(function (i) { return i.product_type === 'Brinde' || (i.properties && i.properties._brinde); });
  }

  function minimo() {
    var el = document.querySelector('[data-inciclo-brinde]');
    return el ? +el.dataset.minimo : null;
  }

  function trocarConteudo(html, seletor, alvo) {
    var novo = new DOMParser().parseFromString(html, 'text/html').querySelector(seletor);
    if (novo && alvo) alvo.innerHTML = novo.innerHTML;
  }

  // Redesenha o carrinho lateral (sem abrir/fechar) ou recarrega a página do carrinho
  function atualizarTela(cart) {
    var gaveta = document.querySelector('cart-drawer');
    if (document.getElementById('main-cart-items') || !gaveta) {
      location.reload();
      return Promise.resolve();
    }
    return json('?sections=cart-drawer,cart-icon-bubble').then(function (secoes) {
      // O botão do PayPal só é montado pelo script da Shopify no carregamento: guarda o que já está pronto e devolve depois
      var paypal = document.querySelector('#CartDrawer .inciclo-pagamento-rapido');
      var montado = paypal ? Array.prototype.slice.call(paypal.childNodes) : [];
      trocarConteudo(secoes['cart-drawer'], '#CartDrawer', document.getElementById('CartDrawer'));
      var novo = document.querySelector('#CartDrawer .inciclo-pagamento-rapido');
      if (novo && montado.length && !novo.querySelector('shopify-accelerated-checkout-cart, shopify-paypal-button, iframe')) {
        novo.innerHTML = '';
        montado.forEach(function (n) { novo.appendChild(n); });
      }
      trocarConteudo(secoes['cart-icon-bubble'], '.shopify-section', document.getElementById('cart-icon-bubble'));
      if (cart) gaveta.classList.toggle('is-empty', cart.item_count === 0);
      var fundo = document.getElementById('CartDrawer-Overlay');
      if (fundo) fundo.addEventListener('click', function () { gaveta.close(); });
    });
  }

  function validar() {
    var min = minimo();
    if (ocupado || min === null) return;
    json('cart.js').then(function (cart) {
      var brindes = brindesNo(cart);
      var semBrinde = cart.total_price - brindes.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      // Brinde cobrado = o desconto do Compre e Ganhe não se aplicou (ex.: cupom de produto que não acumula): sai do carrinho
      var cobrados = brindes.filter(function (i) { return i.final_line_price > 0; });
      var remover = semBrinde < min ? brindes : brindes.slice(1).concat(cobrados);
      remover = remover.filter(function (i, n) { return remover.indexOf(i) === n; });
      var ajustes = {};
      remover.forEach(function (i) { ajustes[i.key] = 0; });
      if (semBrinde >= min && brindes[0] && brindes[0].quantity > 1) ajustes[brindes[0].key] = 1;
      if (!Object.keys(ajustes).length) return;
      ocupado = true;
      json('cart/update.js', { updates: ajustes })
        .then(atualizarTela)
        .finally(function () { ocupado = false; });
    });
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest('[data-inciclo-brinde] [data-variante]');
    if (!botao || botao.disabled || ocupado) return;
    e.preventDefault();
    ocupado = true;
    var caixa = botao.closest('[data-inciclo-brinde]');
    caixa.classList.add('is-carregando');
    caixa.querySelectorAll('[data-variante]').forEach(function (b) { b.disabled = true; });
    json('cart.js')
      .then(function (cart) {
        var ajustes = {};
        brindesNo(cart).forEach(function (i) { ajustes[i.key] = 0; });
        return Object.keys(ajustes).length ? json('cart/update.js', { updates: ajustes }) : null;
      })
      .then(function () { return json('cart/add.js', { items: [{ id: +botao.dataset.variante, quantity: 1, properties: { _brinde: '1' } }] }); })
      .then(function () { return json('cart.js'); })
      .then(atualizarTela, function () { return atualizarTela(); })
      .finally(function () { ocupado = false; });
  });

  // "Aproveite e leve junto": adiciona 1 unidade (da opção escolhida, se houver) e redesenha o carrinho, sem sair dele
  document.addEventListener('click', function (e) {
    var botao = e.target.closest('[data-inciclo-adicionar]');
    if (!botao || ocupado) return;
    e.preventDefault();
    var item = botao.closest('.inciclo-lj__item');
    var opcao = item && item.querySelector('[data-inciclo-opcao]');
    var variante = +(opcao ? opcao.value : botao.dataset.incicloAdicionar);
    ocupado = true;
    botao.disabled = true;
    botao.textContent = 'Adicionando…';
    json('cart/add.js', { items: [{ id: variante, quantity: 1 }] })
      .then(function () { return json('cart.js'); })
      .then(function (cart) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'inciclo-leve-junto', cartData: cart });
        return atualizarTela(cart);
      }, function () { return atualizarTela(); })
      .finally(function () { ocupado = false; });
  });

  function iniciar() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(validar, 400); });
    }
    validar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
